import styled from 'styled-components'
import query from 'syf-component-library/const/mediaQueries'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 48px auto;
  flex-direction: column;
`

export const MFEFullPageWrapper = styled.div`
  max-width: 1200px;
  background: ${({ theme }) => theme.white};
  min-height: 232px;
  @media ${query.greaterThanSmall} {
    border-radius: 10px;
  }
`

export const LoaderContainer = styled.div`
  width: 95%;
  margin: 0 auto;
  height: 230px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export default Container
